import { useEffect, useState } from "react";
import { Outlet } from "react-router";

import Construction from "@/pages/Construction";

// Wrapper component to handle outage state at route level
const OutageWrapper = () => {
    const [apiOutage, setApiOutage] = useState(false);

    useEffect(() => {
        const handleSiteOutage = () => setApiOutage(true);
        window.addEventListener("site-outage-detected", handleSiteOutage);
        return () =>
            window.removeEventListener("site-outage-detected", handleSiteOutage);
    }, []);

    // Proactive API health check for unauthenticated users
    useEffect(() => {
        const checkApiHealth = async () => {
            try {
                const baseUrl = process.env.REACT_APP_BASE_URL;
                if (!baseUrl) return;

                const response = await fetch(`${baseUrl}/system/settings`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                if (response.status === 503 || response.status === 502) {
                    setApiOutage(true);
                }
            } catch {
                // If fetch fails, assume API is down and show maintenance screen
                setApiOutage(true);
            }
        };

        checkApiHealth();
    }, []);

    if (apiOutage) {
        return <Construction />;
    }

    return <Outlet />;
};

export default OutageWrapper;
